import React from "react";
import { motion } from "framer-motion";

interface DeliveryOptionCardProps {
  option: {
    icon: React.ReactNode;
    title: string;
    description: string;
    features: string[];
    color: string;
  };
  index: number;
}

const DeliveryOptionCard: React.FC<DeliveryOptionCardProps> = ({
  option,
  index,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-gray-50 rounded-full p-4 hover:shadow-lg transition-all duration-300 text-center w-full max-w flex flex-col justify-center items-center mx-auto"
    >
      <div
        className={`inline-flex p-3 md:p-4 rounded-full bg-gradient-to-br ${option.color} text-white mb-4 md:mb-6`}
      >
        {option.icon}
      </div>

      <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
        {option.title}
      </h3>

      <p className="text-gray-600 mb-4 md:mb-6 text-sm md:text-base px-2">
        {option.description}
      </p>

      <ul className="space-y-1 md:space-y-2">
        {option.features.map((feature, featureIndex) => (
          <li
            key={featureIndex}
            className="flex items-center justify-center text-gray-700 text-xs md:text-sm"
          >
            <div
              className={`w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-gradient-to-r ${option.color} mr-2`}
            />
            {feature}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default DeliveryOptionCard;
